import { useState } from 'react';
import { MdContentCopy, MdCheck } from 'react-icons/md';
import { cn } from '../../../utils/cn';
import { truncateAddress } from '../../../utils/utils';
import { cofheLogger } from '@/utils/debug';

interface AddressButtonProps {
  address: string | null | undefined;
  className?: string;
  icon?: React.ReactNode;
  showCopyIcon?: boolean;
}

export const AddressButton: React.FC<AddressButtonProps> = ({ address, className, icon, showCopyIcon = true }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyAddress = async () => {
    if (!address) return;
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      cofheLogger.error('Failed to copy address:', err);
    }
  };

  const truncatedAddress = truncateAddress(address) || 'Not connected';

  return (
    <button
      onClick={handleCopyAddress}
      disabled={!address}
      className={cn(
        'flex items-center gap-2 px-2 py-1 rounded cofhe-hover-overlay transition-colors',
        'cofhe-text-primary text-sm',
        className
      )}
    >
      {icon}
      <span className="font-mono">{truncatedAddress}</span>
      {showCopyIcon && address && (copied ? <MdCheck className="w-3 h-3" /> : <MdContentCopy className="w-3 h-3" />)}
      {copied && !showCopyIcon && <span className="text-xs opacity-70">Copied!</span>}
    </button>
  );
};
